<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(nomor)="data">{{ data.index +1}}</template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">
            {{$route.meta.label}} - Add/Edit Form
            <div class="card-header-actions">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-primary mr-1" @click="closeFrm()">
                <i class="fa fa-close"></i> Close Form
              </b-button>
            </div>
          </div>
          <b-input-group label-cols="3">
            <b-input-group-prepend>
              <label>Tanggal</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdata.tanggal" :state="!$v.frmdata.tanggal.$error" type="date"></b-form-input>
          </b-input-group>
          <b-input-group label-cols="3">
            <b-input-group-prepend>
              <label>Uraian</label>
            </b-input-group-prepend>
            <b-form-textarea
              id="textarea"
              v-model="frmdata.uraian"
              placeholder="Uraian"
              rows="3"
              max-rows="6"
              :state="!$v.frmdata.uraian.$error"
            ></b-form-textarea>
          </b-input-group>
          <b-input-group label-cols="3">
            <b-input-group-prepend>
              <label>Periode Campaign</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.startdate"
              :state="!$v.frmdata.startdate.$error"
              type="date"
            ></b-form-input>
            <b-input-group-append is-text>untill</b-input-group-append>
            <b-form-input v-model="frmdata.enddate" :state="!$v.frmdata.enddate.$error" type="date"></b-form-input>
          </b-input-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      tanggal: { required },
      uraian: { required },
      startdate: { required },
      enddate: { required }
    }
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList: true,
      showForm: false,
      showFilter: false,
      frmdata: { tanggal: null, uraian: null, startdate: null, enddate: null },
      tblData: {
        tablename: "salescampaign",
        page: 1,
        limit: 20,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: null,
        sortDesc: false
      }
    };
  },
  components: {},
  computed: {
    tblFields() {
      const fields = [
        {
          key: "tanggal",
          thStyle: "width:100px",
          label: "Tanggal"
        },
        {
          key: "uraian",
          label: "Uraian",
          sortable: true
        },
        {
          key: "startdate",
          label: "Tanggal Mulai",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "enddate",
          label: "Tanggal Berakhir",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },

        {
          key: "action",
          label: "Action",
          thStyle: "width:100px",
          thClass: "text-center"
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  created: async function() {},
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await crud.list(this.tblData);
      list.forEach((el, idx) => {
        list[idx].tanggal = moment(el.tanggal).format("YYYY-MM-DD");
        list[idx].startdate = moment(el.startdate).format("YYYY-MM-DD");
        list[idx].enddate = moment(el.enddate).format("YYYY-MM-DD");
      });
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.koran = "";
      this.tblData.iklan = "";
      this.tblData.collector_name = "";
      this.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.kodelama = data.campaignKey;
      let _selected;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        // console.log("validation : ", this.$v.frmdata);
        // console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        let data = {};
        let keys = [];
        try {
          if (this.frmdata.kodelama) {
            data = {};
            keys = [`campaignKey`, `tanggal`, `uraian`, `startdate`, `enddate`];
            for (const iterator of keys) {
              data[iterator] = this.frmdata[iterator];
            }
            await crud.update({
              tablename: "salescampaign",
              key: this.frmdata.kodelama,
              data: data
            });
          } else {
            data = {};
            keys = [`tanggal`, `uraian`, `startdate`, `enddate`];
            for (const iterator of keys) {
              data[iterator] = this.frmdata[iterator];
            }
            await crud.insert({
              tablename: "salescampaign",
              data: data
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({
        tablename: "salescampaign",
        key: this.model.campaignKey
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
